export const brl = (v) => `R$ ${(Number(v) || 0).toFixed(2).replace('.', ',')}`;
